import _ from 'lodash';
import Api from '../../../services/api';
import LoginService from '../../../services/login.service';

export default {
    getJSON: function (url, payload, method = 'GET', responseType = "json") {
        if (_.isEmpty(url)) {
            throw new Error('Mandatory argument \'url\' seems to be missing or invalid.');
        }

        return Api.request({
            url,
            method,
            responseType,
            data: payload
          })
          .then(response => {
            return response.data;
          })
          .catch((error)=> {
            if (LoginService.shouldLogout()) {
              LoginService.logout();
            } else {
              if (!LoginService.isLoggedOut) {
                  console.error('Failed Request', error);
                  throw error;
              }
            }
          });
    },

    getBlob: function (url, payload, method = 'POST', filename, progress) {
        if (_.isEmpty(url)) {
            throw new Error('Mandatory argument \'url\' seems to be missing or invalid.');
        }

        return Api.request({
            url,
            method,
            responseType: 'blob',
            data: payload,
            onDownloadProgress: progress
          })
          .then(result => {
            // Download the file
            let data = result.data;
            let disposition = result.headers['content-disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
              let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              let matches = filenameRegex.exec(disposition);
              if (matches && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
              }
            }

            if (window.navigator && window.navigator.msSaveBlob) { // for IE/edge
              window.navigator.msSaveBlob(data, filename);
            } else { // for Non-IE (chrome, firefox etc.)
              let a = document.createElement('a');
              let url = window.URL.createObjectURL(data);
              a.href = url;
              a.download = filename;

              document.body.append(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            }

            return result;
          });
    }
};
